import React from 'react';
import ReactDOM from 'react-dom';
import Immutable from 'seamless-immutable';
import EpicGamesNav from './EpicGamesNav';
import addObserverCallback from './utils/epicGamesNavObserver';
import 'console-shim';
import root from 'window-or-global';

const renderNav = () => {
    const config = root._epicGamesNavObserver.subject;
    const epicPropertyName = config.epicPropertyName;
    const epicPropertyClasses = config.epicPropertyClasses;
    const isLoggedIn = config.isLoggedIn;
    const links = Immutable(config.links);
    const hideLocale = config.hideLocale;
    const hideSearch = config.hideSearch;
    const hideSignIn = config.hideSignIn;
    const hideCallToAction = config.hideCallToAction;
    const callToAction = Immutable(config.callToAction);
    const localeOptions = Immutable(config.localeOptions);
    const logoLink = Immutable(config.logoLink);
    const accountLinks = Immutable(config.accountLinks);
    const downloadLink = Immutable(config.downloadLink);
    const displayName = config.displayName;
    const locale = config.locale;
    const messages = Immutable(config.messages);
    const properties = Immutable(config.properties);
    const onSearch = config.onSearch;
    const pcDownloadUrl = config.pcDownloadUrl;
    const macDownloadUrl = config.macDownloadUrl;
    const country = config.countryCode;
    const isEu = config.isEu;
    const euCookie = config.euCookieStrings;
    euCookie.policyUrl = config.policyUrl;
    const globalLinkOnClick = config.globalLinkOnClick;
    const shieldOnClick = config.shieldOnClick;

    ReactDOM.render(
        <EpicGamesNav
            epicPropertyName={epicPropertyName}
            epicPropertyClasses={epicPropertyClasses}
            isLoggedIn={isLoggedIn}
            links={links}
            hideLocale={hideLocale}
            hideSearch={hideSearch}
            hideSignIn={hideSignIn}
            downloadLink={downloadLink}
            hideCallToAction={hideCallToAction}
            callToAction={callToAction}
            localeOptions={localeOptions}
            logoLink={logoLink}
            displayName={displayName}
            locale={locale}
            country={country}
            accountLinks={accountLinks}
            messages={messages}
            properties={properties}
            onSearch={onSearch}
            pcDownloadUrl={pcDownloadUrl}
            macDownloadUrl={macDownloadUrl}
            isEu={isEu}
            euCookie={euCookie}
            globalLinkOnClick={globalLinkOnClick}
            shieldOnClick={shieldOnClick} />,
        root.document.getElementById('epicGamesNavigation')
    );
};

addObserverCallback(renderNav);
renderNav();
